import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { Radio, Cascader } from '@roo/roo';
import { useSimpleContext } from '../../_context';

const Root = styled.div`
  &.t-single {
    .mixed {
      input {
        border-color: rgb(233, 234, 242) !important;
      }
    }
  }
  &.t-mixed {
    .single {
      input {
        border-color: rgb(233, 234, 242) !important;
      }
    }
  }
  .roo-radio,
  .dropdown {
    margin-bottom: 9px;
  }
`;

function Area(props) {
  const {
    setFieldValue,
    validateField,
    // 类型： 专一领域 交叉领域
    type,
    // 路径
    studyAreaPath,
    studyAreaKey = 'studyArea',
    typeKey = 'studyAreaType',
    tip = '请选择所属学科领域',
  } = props;
  const { state } = useSimpleContext((t) => [t.scientist.subjects]);
  const [a = '', b = ''] = studyAreaPath || [];
  // 专一领域、交叉领域1
  const [aPath, setAPath] = React.useState(a.split('-').filter(Boolean).map(Number));
  // 交叉领域2
  const [bPath, setBPath] = React.useState(b.split('-').filter(Boolean).map(Number));

  const opts = useMemo(
    () => {
      const pa = aPath.join('-');
      const pb = bPath.join('-');
      function loop(data = []) {
        return data.map(({
          id, name, children, path,
        }) => ({
          label: name,
          value: id,
          children: children ? loop(children) : undefined,
          disabled: [pa, pb].includes(path) ? true : undefined,
        }));
      }
      return { sub1: loop(state.scientist.subjects), sub2: loop(state.scientist.subjects2) };
    },
    [state.scientist.subjects, aPath, bPath],
  );

  function validate() {
    setTimeout(() => {
      validateField('studyArea');
    }, 0);
  }

  useEffect(() => {
    setFieldValue(studyAreaKey, [[...aPath].pop(), [...bPath].pop()].filter(Boolean));
  }, [aPath, bPath]);

  return (
    <Root className={type === 1 ? 't-single' : 't-mixed'}>
      <div className="area-group single">
        <Radio
          checked={type === 1}
          disabled={props.disabled}
          onChange={() => {
            setAPath([]);
            setBPath([]);
            setFieldValue(studyAreaKey, []);
            setFieldValue(typeKey, 1);
          }}
        >
          专一领域
        </Radio>
        <Cascader
          value={type === 1 ? aPath : []}
          options={opts.sub1}
          disabled={props.disabled || type === 2}
          placeholder={tip}
          onChange={(value) => {
            setAPath(value);
            setFieldValue(studyAreaKey, [[...value].pop()]);
            validate();
          }}
        />
      </div>
      <div className="area-group mixed" style={{ marginTop: 32 }}>
        <Radio
          checked={type === 2}
          disabled={props.disabled}
          onChange={() => {
            setAPath([]);
            setBPath([]);
            setFieldValue(studyAreaKey, []);
            setFieldValue(typeKey, 2);
          }}
        >
          前沿交叉
        </Radio>
        <Cascader
          disabled={props.disabled || type === 1}
          value={type === 2 ? aPath : []}
          options={opts.sub1}
          placeholder={tip}
          onChange={(v) => {
            setAPath(v);
            setFieldValue(studyAreaKey, [[...v].pop(), [...bPath].pop()].filter(Boolean));
            validate();
          }}
        />
        <Cascader
          disabled={props.disabled || type === 1}
          value={type === 2 ? bPath : []}
          options={opts.sub2}
          placeholder={tip}
          onChange={(v) => {
            setBPath(v);
            setFieldValue(studyAreaKey, [[...aPath].pop(), [...v].pop()].filter(Boolean));
            validate();
          }}
        />
      </div>
    </Root>
  );
}

export default Area;
